import axios from "axios";

const API_PATH = '/manage/common/forget';

const SendEmail = async searches => (
	await axios.put(API_PATH, searches)
);

export { SendEmail };
